'use client';
import React from 'react';
import Link from 'next/link';
import { ProductTitle as SharedProductTitle } from '@launchstore/shared-puck';
import type { ProductTitleProps } from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import { usePuckContext } from '@/components/puck/PuckContextProvider';
import type { ProductData } from '@launchstore/shared-puck';

const toProductData = (p: any): ProductData | null => {
  if (!p) return null;
  return {
    id: p.id,
    title: p.title,
    handle: p.handle,
    description: p.description,
    material: p.material,
    weight: p.weight,
    length: p.length,
    width: p.width,
    height: p.height,
    origin_country: p.origin_country,
    metadata: p.metadata,
    variants: (p.variants || []).map((v: any) => ({
      id: v.id,
      sku: v.sku,
      weight: v.weight,
      length: v.length,
      width: v.width,
      height: v.height,
    })),
  };
};

const SharedProductTitleRender = (SharedProductTitle as any).render;

const ProductTitleImpl: React.FC<ProductTitleProps> = (props: any) => {
  const { product } = useProduct();

  // Card mode — the title links to the product page
  const puckContext = (usePuckContext() as any)?.context;
  if (puckContext?.productCard && product?.handle) {
    const countryCode = puckContext.countryCode || 'us';
    return (
      <Link href={`/${countryCode}/products/${product.handle}`} className="block hover:underline">
        <SharedProductTitleRender {...(props as any)} product={toProductData(product)} />
      </Link>
    );
  }

  return <SharedProductTitleRender {...(props as any)} product={toProductData(product)} />;
};

export const ProductTitle: any = { ...SharedProductTitle, render: (props: any) => <ProductTitleImpl {...props} /> };
export default ProductTitle;
